export const WxFields = {
  w9_form: [
    'tax_classification',
    'first_name',
    'middle_name',
    'last_name',
    'tax_id',
    'legal_name',
    'company_name',
    'address',
    'address_2',
    'city',
    'state',
    'zip',
  ],
  w8bene_form: [
    'legal_name',
    'company_name',
    'address',
    'address_2',
    'city',
    'state',
    'zip',
    'payment_country',
    'payment_billing_address',
    'payment_billing_address_2',
    'payment_city',
    'payment_state',
    'payment_zip',
    'country',
  ],
  w8ben_form: [
    'first_name',
    'middle_name',
    'last_name',
    'country',
    'address',
    'address_2',
    'city',
    'state',
    'zip',
    'payment_billing_address',
    'payment_billing_address_2',
    'payment_country',
    'payment_city',
    'payment_state',
    'payment_zip',
    'is_individual',
  ],
};
